/* Hanwu SGS v1.0.0. Native forms work without JavaScript. No external dependencies. */
(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');

  function closeMenus(except = null) {
    document.querySelectorAll('[data-mobile-menu][open], .nav-dropdown[open]').forEach(menu => {
      if (menu !== except) menu.removeAttribute('open');
    });
  }

  function bindProduct(section) {
    if (!section || section.dataset.productBound === 'true') return;
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-variant-price]');
    const compare = section.querySelector('[data-variant-compare]');
    const button = section.querySelector('[data-add-button]');
    const quantity = section.querySelector('[data-product-quantity]');
    if (!select || !price || !button) return;
    section.dataset.productBound = 'true';
    select.addEventListener('change', () => {
      const selected = select.selectedOptions[0];
      if (!selected) return;
      price.textContent = selected.dataset.price || '';
      if (compare) {
        compare.textContent = selected.dataset.compare || '';
        compare.hidden = !selected.dataset.compare;
      }
      const available = selected.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
      if (quantity) {
        const minimum = Math.max(1, Number(selected.dataset.min) || 1);
        const step = Math.max(1, Number(selected.dataset.step) || 1);
        const maximum = Number(selected.dataset.max) || null;
        quantity.min = String(minimum);
        quantity.step = String(step);
        if (maximum !== null) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        quantity.value = String(minimum);
      }
      // Never change the server action or fabricate an add-to-cart response.
      if (window.location.protocol === 'http:' || window.location.protocol === 'https:') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url.toString());
      }
      if (selected.dataset.image) {
        const media = Array.from(section.querySelectorAll('[data-media-id]'))
          .find(node => node.dataset.mediaId === selected.dataset.image);
        if (media && window.matchMedia('(min-width: 900px)').matches) {
          media.scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      }
    });
  }

  function initialize(root = document) {
    if (root.matches && root.matches('[data-product-section]')) bindProduct(root);
    root.querySelectorAll('[data-product-section]').forEach(bindProduct);
  }

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (!target.closest('[data-mobile-menu], .nav-dropdown')) closeMenus();
    if (target.closest('.mobile-menu__panel a')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector('[data-mobile-menu][open], .nav-dropdown[open]');
    if (openMenu) {
      closeMenus();
      openMenu.querySelector('summary')?.focus();
    }
  });
  // Shopify's editor replaces sections without a full page reload.
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => closeMenus());
  document.addEventListener('shopify:block:select', event => {
    const details = event.target instanceof Element ? event.target.closest('details') : null;
    if (details) details.open = true;
  });
  initialize();
})();
